import { useQuery } from '@tanstack/react-query'
import { ArrowLeft } from 'lucide-react'
import { Link } from 'react-router-dom'

import { ProductCard } from '@/components/ProductCard'
import { SectionTitle } from '@/components/ui/SectionTitle'
import { publicApi } from '@/lib/api'
import { getSiteListingCopy } from '@/lib/siteListingMode'
import { getFallbackSiteSettings } from '@/lib/siteSettingsCache'

export function ProductCatalogPage() {
  const productsQuery = useQuery({
    queryKey: ['public-products'],
    queryFn: publicApi.listProducts,
    staleTime: 30_000,
  })
  const siteSettingsQuery = useQuery({
    queryKey: ['public-site-settings'],
    queryFn: publicApi.getSiteSettings,
    initialData: getFallbackSiteSettings(),
  })
  const siteSettings = siteSettingsQuery.data ?? getFallbackSiteSettings()
  const listingCopy = getSiteListingCopy(siteSettings.listingMode)

  return (
    <div className="page-stack product-catalog-page">
      <section className="product-catalog-page__head">
        <Link className="back-link" to="/">
          <ArrowLeft size={16} />
          返回首页
        </Link>
        <div className="page-stack compact">
          <SectionTitle eyebrow={listingCopy.catalogEyebrow} title={listingCopy.catalogTitle} />
          <p className="muted-text">{listingCopy.catalogLead}</p>
        </div>
      </section>
      <div className="product-grid product-grid--landing">
        {productsQuery.data?.map(product => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  )
}
